import Entity from "entity";

export default class Implemento extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/uSbusbT6lSycOXm6GgeL/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("numeroFrotaImplemento");
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "numeroFrotaImplemento";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Cód.", flex: 0.8, filter: true, type: 'number', },
            { field: "cliente.nome", headerName: "Cliente", flex: 1, filter: true },
            { field: "numeroFrotaImplemento", headerName: "Nº Frota", flex: 1, filter: true },
            { field: "marcaImplemento", headerName: "Marca", flex: 1, filter: true },
            { field: "nomeImplemento", headerName: "Implemento", flex: 1, filter: true },
            { field: "modeloImplemento", headerName: "Operador", flex: 1 },
        ];
    }
}
